<script>
    import { DoubleBounce } from "svelte-loading-spinners";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let isConfirmActionModalOpen = false,
        isActionRunning = false,
        title = "",
        confirmPrompt = "",
        confirmButtonText = "Yes",
        cancelButtonText = "No";

    let previousKeyDown;

    $: if (isConfirmActionModalOpen) {
        previousKeyDown = document.onkeydown;
        enableCloseDeleteWithESC();
    } else {
        document.onkeydown = previousKeyDown;
    }

    const enableCloseDeleteWithESC = () => {
        document.onkeydown = (event) => {
            if (event.key === "Escape") {
                cancelDelete();
            }
        };
    };

    const cancelDelete = () => {
        isConfirmActionModalOpen = false;
        dispatch("cancelAction");
    };

    const confirmDelete = () => {
        dispatch("confirmAction");
    };
</script>

<div class={isConfirmActionModalOpen ? "modal modal-open z-[10001]" : "modal"}>
    <div class="modal-box w-auto min-w-[390px] max-w-full p-0">
        <h3 class="font-medium text-[18px] text-left text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3">
            {title}
        </h3>
        <div class="flex flex-col p-6">
            <p class="leading-6 text-[16px] text-left">
                {confirmPrompt}
            </p>
        </div>

        <div class="modal-action flex-1 justify-end gap-x-4 px-6 pb-6">
            <button
                class="w-auto min-w-[96px] btn btn-error btn-sm text-white text-[14px] rounded-md"
                on:click={cancelDelete}>{cancelButtonText ?? "No"}</button
            >
            <button
                class="w-auto min-w-[96px] btn btn-secondary btn-sm text-white text-[14px] rounded-md ml-0"
                on:click={confirmDelete}
                disabled={isActionRunning}
            >
                {#if isActionRunning}
                    <DoubleBounce
                        size="12"
                        color="#FF3E00"
                        unit="px"
                        duration="1s"
                    />
                {:else}
                    {confirmButtonText ?? "Yes"}
                {/if}
            </button>
        </div>
    </div>
</div>
